import { createStore } from '@servicetitan/financing-utils-shared';
import { useState } from 'react';

export interface ConsentData {
    applicantConsent: boolean | undefined;
    coApplicantConsent: boolean | undefined;
}

function useConsentData(
    initialState: ConsentData = {
        applicantConsent: undefined,
        coApplicantConsent: undefined,
    },
) {
    const [consentData, setConsentData] = useState(initialState);
    return { consentData, setConsentData };
}

export const ConsentDataStore = createStore(useConsentData);

export type ConsentDataStore = ReturnType<typeof useConsentData>;
